module.exports = __webpack_public_path__ + "static/media/IMG_20160605_163040.a608f22f.jpg";